import React from "react";
import { NavLink, Route, Switch } from "react-router-dom";
import { Panel } from "@culturehq/components";

import { useProfile } from "app/context";
import { t } from "app/utils";

import RecognitionTypes from "./settings/RecognitionTypes";
import AutoRecognitions from "./settings/AutoRecognitions";
import Recognitions from "./Recognitions";

const SettingOption = ({ to, phrase }) => (
  <li role="navigation">
    <NavLink to={to} activeClassName="active">{phrase}</NavLink>
  </li>
);

const RecognitionsOptions = () => {
  const { profile } = useProfile();
  const { organization: { isEducational, recognitionsEnabled } } = profile;

  return (
    <Panel limitWidth>
      <ul role="tablist" aria-label={t("Settings options")} className="nav nav-tabs">
        {!isEducational && recognitionsEnabled && (
          <>
            <SettingOption to="/admin/recognition-types" phrase={t("Recognition Types")} />
            <SettingOption to="/admin/auto-recognitions" phrase={t("Auto Recognitions")} />
            <SettingOption to="/admin/pending-recognitions" phrase={t("Pending Recognitions")} />
          </>
        )}
      </ul>
      <Panel.Body>
        <Switch>
          {!isEducational && recognitionsEnabled && (
            <>
              <Route exact path="/admin/recognition-types/:page?" component={RecognitionTypes} />
              <Route exact path="/admin/auto-recognitions" component={AutoRecognitions} />
              <Route exact path="/admin/pending-recognitions" component={Recognitions} />
            </>
          )}
        </Switch>
      </Panel.Body>
    </Panel>
  );
};

export default RecognitionsOptions;
